import { render, staticRenderFns } from "./addCopilotModal.vue?vue&type=template&id=f6a18bd8&"
import script from "./addCopilotModal.vue?vue&type=script&lang=js&"
export * from "./addCopilotModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports